
export function iconShow(item) {
    let index = item.Name.lastIndexOf('.')
    if(index == -1) {
        item.FileExt = ""
    } else {
        item.FileExt =  item.Name.substr(index)
    }
    if(!item.FileExt){
        return '#icon-wenjianjia'
    }else if(item.FileExt=='.png'){
        return '#icon-png'
    }else if(item.FileExt=='.jpg'){
        return '#icon-Jpg'
    }else if(item.FileExt=='.gif'){
        return '#icon-GIF'
    }else if(item.FileExt=='.jpeg'){
        return '#icon-JPEG'
    }else if(item.FileExt=='.xls'){
        return '#icon-excel'
    }else if(item.FileExt=='.dwg'){
        return '#icon-dwg'
    }else if(item.FileExt=='.ppt'){
        return '#icon-PPT'
    }else if(item.FileExt=='.wmv'){
        return '#icon-wmv'
    }else if(item.FileExt=='.flv'){
        return '#icon-FLV'
    }else if(item.FileExt=='.doc'){
        return '#icon-word'
    }else if(item.FileExt=='.pdf'){
       return '#icon-pdf'
    }else if(item.FileExt=='.zip'||item.FileExt=='.rar'){
        return '#icon-yasuobao'
    }else if(item.FileExt=='.docx'){
        return '#icon-DOCX'
    }else if(item.FileExt=='.pptx'){
        return '#icon-pptx'
    }else if(item.FileExt=='.xlsx'){
        return '#icon-XLSX'
    }else if(item.FileExt=='.mp4'){
        return '#icon-mp'
    }else if(item.FileExt=='.avi'){
        return '#icon-AVI'
    }else{
        return '#icon-wenjian'
    }
}

export function filterAuditStatus(val){
    if(val==1){
        return '待送审'
    }else if(val==2){
        return '审核中'
    }else if(val==3){
        return '不通过'
    }else if(val==4){
        return '通过'
    }
}


// WEBPACK FOOTER //
// ./src/utils/document.js